// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"dba16419","160":"77d992c6","208":"ae67d961","293":"29267fd7","453":"a7d99afe","516":"4d8c1e6c","519":"c11b2054","917":"73ac6f41","946":"810cb885"}[chunkId] + ".chunk.js";
};